export const quickSearchTabs = (hideFmcsa, isDemoMode, trialAccount, motusEnabled, samgovEnabled, nppesEnabled, leieEnabled, stateMedicaidEnabled, healthcareSearchEnabled) => {
    // When Healthcare Search is enabled, the individual healthcare sources (SAM.gov, NPPES, LEIE)
    // fold into it — one unified surface for the operator rather than four semi-overlapping tabs.
    // State Medicaid stays separate: different scope, different admin workflow.
    return [
        { label: "FMCSA", hidden: hideFmcsa },
        { label: "UCC", hidden: trialAccount },
        { label: "SOS", hidden: trialAccount },
        { label: "MOTUS", hidden: !motusEnabled },
        { label: "SAM.gov", hidden: !samgovEnabled || healthcareSearchEnabled },
        { label: "NPPES", hidden: !nppesEnabled || healthcareSearchEnabled },
        { label: "LEIE", hidden: !leieEnabled || healthcareSearchEnabled },
        { label: "State Medicaid", hidden: !stateMedicaidEnabled || healthcareSearchEnabled },
        { label: "Healthcare Search", hidden: !healthcareSearchEnabled },
    ]
}
